/**
 * Theme JavaScript
 * Handles interactive functionality for the Shopify theme
 */

(function() {
  'use strict';

  /**
   * Product variant selector handling
   */
  function initProductVariants() {
    const productForm = document.querySelector('.product__form');
    if (!productForm) return;

    const variantSelects = productForm.querySelectorAll('.product__option-select');
    const variantIdInput = productForm.querySelector('input[name="id"]');
    const submitButton = productForm.querySelector('.product__submit');

    variantSelects.forEach(select => {
      select.addEventListener('change', updateVariant);
    });

    function updateVariant() {
      const selectedOptions = [];
      variantSelects.forEach(select => {
        selectedOptions.push(select.value);
      });

      // Find matching variant
      const variants = window.productVariants || [];
      const selectedVariant = variants.find(variant => {
        return variant.options.every((option, index) => option === selectedOptions[index]);
      });

      if (selectedVariant) {
        variantIdInput.value = selectedVariant.id;

        // Update button state
        if (selectedVariant.available) {
          submitButton.disabled = false;
          submitButton.textContent = 'Add to cart';
        } else {
          submitButton.disabled = true;
          submitButton.textContent = 'Sold out';
        }

        // Update price display
        updatePrice(selectedVariant);
      }
    }

    function updatePrice(variant) {
      const priceElement = document.querySelector('.product__price');
      if (!priceElement) return;

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceElement.innerHTML = `
          <span class="product__price--sale">${formatMoney(variant.price)}</span>
          <span class="product__price--compare">${formatMoney(variant.compare_at_price)}</span>
        `;
      } else {
        priceElement.innerHTML = `<span>${formatMoney(variant.price)}</span>`;
      }
    }
  }

  /**
   * Product image gallery
   */
  function initProductGallery() {
    const thumbnails = document.querySelectorAll('.product__thumbnail');
    const mainImage = document.querySelector('.product__image');

    if (!thumbnails.length || !mainImage) return;

    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', function() {
        // Update active state
        thumbnails.forEach(t => t.classList.remove('product__thumbnail--active'));
        this.classList.add('product__thumbnail--active');

        // Update main image
        const img = this.querySelector('img');
        if (img) {
          mainImage.src = img.src.replace('100x', '800x');
          mainImage.srcset = img.src.replace('100x', '800x');
        }
      });
    });
  }

  /**
   * Cart quantity update
   */
  function initCartQuantity() {
    const quantityInputs = document.querySelectorAll('.cart__quantity-input');

    quantityInputs.forEach(input => {
      input.addEventListener('change', function() {
        const form = this.closest('form');
        if (form) {
          form.submit();
        }
      });
    });
  }

  /**
   * Format money helper
   */
  function formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }

  /**
   * Initialize on DOM ready
   */
  document.addEventListener('DOMContentLoaded', function() {
    initProductVariants();
    initProductGallery();
    initCartQuantity();
  });
})();
